export const getValueIndicatorPosition = (value: number, min: number, max: number, width: number) => {
  if (min >= max) {
    return width / 2;
  }

  return Math.max(0, Math.min(width, (width * (value - min)) / (max - min)));
};
